import React from 'react'
import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components/macro'
import { fetchUpdateMe, selectIsAuth } from '../../redux/slices/auth'
import { useTranslation } from 'react-i18next'
import pencil from './../../assets/pencil.png'

const Description = styled.section`
margin-left: 25px;
margin-bottom: 30px;
position: relative;

@media (max-width: 577px){
  margin: 0;
  padding: 80px 20px;
}
`
const Head = styled.h2`
font-family: 'Palatino';
font-weight: 400;
border-bottom: 0.5px solid rgba(215, 215, 215, 1);
line-height: 35px;
display: flex;
img{
  width: 20px;
  opacity: 0.9;
  margin: 0 1rem;
  cursor: pointer;
}

span{
  font-size: 18px;
  opacity: 0.9;
  font-family: 'Montserrat';
  margin-left: 10px;
  margin-top: 2px;
}

input{
  margin-top: -1rem;
  margin-bottom: 1rem;
  width: 470px;
  height: 35px;
  border: 1px solid #949494;
  border-radius: 10px;
  outline: none;
  text-indent: 5px;
}

@media (max-width: 577px) {
  flex-direction: row;
  align-items: flex-start;
}
`

const StatusField = styled.input`
  margin-top: -1rem;
  margin-bottom: 1rem;
  width: 470px;
  height: 35px;
  border: 1px solid #949494;
  border-radius: 10px;
  outline: none;
  text-indent: 5px;

  @media (max-width: 577px) {
    flex: 1;
    width: auto;
    height: 35px;
    margin-top: 0;
    margin-bottom: 0.5rem;
    padding: 6px 10px;
    text-indent: 0;
    font-family: 'Montserrat', sans-serif;
    font-size: 14px;
    line-height: 20px;
    resize: none;
    overflow: hidden;
    box-sizing: border-box;
    white-space: pre-wrap;
    word-break: break-word;
  }
`

const Save = styled.button`
width: 150px;
height: 35px;
background: rgba(254,97,3,0.16);
border: 1px solid rgba(0, 0, 0, 0);
border-radius: 15px;
font-family: 'Montserrat';
font-size: 17px;
margin-top: -1rem;
margin-left: 2rem;
opacity: 1;
z-index: 12;
transition: 0.3s ease;
cursor: pointer;

&:hover{
  opacity: 1;
}

@media (max-width: 577px) {
  width: 90px;
  font-size: 14px;
  margin-left: 8px;
  margin-top: 0;
  margin-bottom: 0.5rem;
  flex-shrink: 0;
}
`

const Body = styled.p`
margin-top: 1.7rem;
font-family: 'Montserrat';
font-size: 17px;
font-weight: 400;
display: flex;
line-height: 25px;
white-space: pre-wrap;
word-break: break-word;

img{
  width: 20px;
  height: 20px;
  opacity: 0.9;
  margin: -0.3rem 0.5rem;
  margin-left: auto;
  cursor: pointer;
}

textarea{
  font-family: 'Montserrat';
  width: 526px;
  height: 160px;
  border: 1px solid #949494;
  border-radius: 10px;
  outline: none;
  resize: none;
  padding: 5px 5px;
}
`

const SaveDesc = styled.button`
width: 150px;
height: 35px;
background: rgba(254,97,3,0.16);
border: 1px solid rgba(0, 0, 0, 0);
border-radius: 15px;
font-family: 'Montserrat';
font-size: 17px;
margin-top: 0rem;
margin-left: 2rem;
opacity: 1;
z-index: 12;
transition: 0.3s ease;
cursor: pointer;

&:hover{
  opacity: 1;
}
`

const Text = () => {
  const isAuth = useSelector(selectIsAuth)
  const dispatch = useDispatch()
  const [isShown, setIsShown] = React.useState(false)
  const [Desc, setDesc] = React.useState(false)
  const { t } = useTranslation();

  const [isMobile, setIsMobile] = React.useState(
    typeof window !== 'undefined' ? window.innerWidth <= 577 : false
  )

  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 577)
    }
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const {
    register: registerDesc, 
    handleSubmit: handleSubmitDesc, 
  } = useForm({
    defaultValues: {
      description: isAuth.description,
    },
    mode: 'onChange'
  })

  const { register, handleSubmit, watch } = useForm({
    defaultValues: {
      status: isAuth.status,
    },
    mode: 'onChange'
  })

  const statusValue = watch('status')
  const { ref: statusRegisterRef, ...statusRegisterRest } = register('status')

  const adjustHeight = React.useCallback((node) => {
    if (node && isMobile) {
      node.style.height = '0px'

      const minHeight = 35
      const targetHeight = Math.max(minHeight, node.scrollHeight)

      node.style.height = `${targetHeight}px`
    }
  }, [isMobile])

  const statusRef = React.useCallback((node) => {
    statusRegisterRef(node)
    adjustHeight(node)
  }, [statusRegisterRef, adjustHeight])

  React.useEffect(() => {
    const textarea = document.querySelector('textarea.status-textarea')
    if (textarea) {
      adjustHeight(textarea)
    }
  }, [statusValue, isShown, adjustHeight])

  const toggle = () => {
    setIsShown(!isShown);
  }

  const toggleDesc = () => {
    setDesc(!Desc);
  }

  const onSubmit = async (values) => {
    const data = await dispatch(fetchUpdateMe(values))

    if (!data.payload) {
      return alert('Не удалось авторизоваться')
    }

    setIsShown(false);
    setDesc(false);
  }

  return (
    <>
      <Description>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Head>
            {!isShown ? (
              <div>
                {isAuth.status === '' ? (
                  <>{t('justStatus')} <span>({t('inEhglish')})</span> </>
                ) : (
                  <>{isAuth.status}</>
                )}
                <img src={pencil} alt='Pencil' onClick={toggle}/> 
              </div> 
            ) : (
              <>      
                <StatusField 
                  as={isMobile ? 'textarea' : 'input'} 
                  type={isMobile ? undefined : 'text'}
                  className={isMobile ? 'status-textarea' : ''}
                  ref={statusRef}
                  {...statusRegisterRest}
                />
                <Save type="submit">{t('saveBanner')}</Save>
              </>
            )}
          </Head>
        </form>
        <form onSubmit={handleSubmitDesc(onSubmit)}>
          {!Desc ? (
            <Body>
              {isAuth.description === '' ? t('descriptionYourStore') : <>{isAuth.description}</>}
              <img src={pencil} alt='Pencil' onClick={toggleDesc}/>
            </Body>
          ) : (
            <Body>
              <textarea {...registerDesc('description')}></textarea>
              <SaveDesc type="submit">{t('saveBanner')}</SaveDesc>
            </Body>
          )}
        </form>
      </Description>
    </>
  )
}

export default Text